import { createFilterStore } from './createFilterStore';

export const useCompanyFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  industry: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
